// import ModalForm from "./Form";
import SchoolHistoryTableForm from "./SchoolHistoryTableForm";
import SchoolHistoryTableFormAdd from "./SchoolHistoryTableFormAdd";
import {
	SCHOOL_HISTORY,
	DATATABLE_EXPORT,
} from "../../../../../../Config/ApiUrl";
import * as actions from "../../../../../../Config/ApiUrl";

export const Schema = {
	components: { SchoolHistoryTableForm,SchoolHistoryTableFormAdd },

	data() {
		return {
			DATATABLE_EXPORT,
			isAddEditModalActive: false,
			isAddModalActive: false,
			deleteConfirmationModalActive: false,
			deleteLoader: false,
			selectedUrl: this.ENDPOINT,
			Endpoint:
				SCHOOL_HISTORY + "?clc_id_number=" + this.value.clc_id_number,
			tableId: "school-history-table",
			formId: "school-history-table-form",
			formIdAdd: "school-history-table-form-add",
			rowData: {},
			tableColumns: [
				{
					title: "School Name",
					type: "custom-html",
					key: "school",
					isVisible: true,
					modifier: (value, row) => {
						if (!value || !value.name) {
							return "";
						}
						if (value.name === "Others") {
							const otherSchool = row.school_name_other;

							return `<span>${this.$t(value.name)}${
								otherSchool ? ` (${this.$t(otherSchool)})` : ""
							}</span>`;
						}

						return `<span>${this.$t(value.name)}</span>`;
					},
				},
				
				{
					title: "School Level",
					type: "text",
					key: "school_level_names",
				},
				{
					title: "Have Chinese Lesson at School",
					type: "custom-html",
					key: "is_chinese_lesson",
					isVisible: true,
					modifier: (value) => {
						// let checked_yes = value === 1 ? "checked" : "";
						// let checked_no = value === 0 ? "checked" : "";
						// return 2 radio buttons 'Yes' and 'No'
						// return `<div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline1" name="customRadioInline1" class="custom-control-input" ${checked_yes}> <label class="custom-control-label" for="customRadioInline1">Yes</label> </div> <div class="custom-control custom-radio custom-control-inline"> <input type="radio" id="customRadioInline2" name="customRadioInline1" class="custom-control-input" ${checked_no}> <label class="custom-control-label" for="customRadioInline2">No</label> </div>`;
						if (value === 1) {
							return `<span>Yes</span>`;
						} else if (value === 0) {
							return `<span>No</span>`;
						}
					},
				},
			],
			actionObj: {
				title: this.$t("action"),
				type: "action",
			},
			options: {
				name: "SchoolHistoryTable",
				url:
					SCHOOL_HISTORY +
					"?clc_id_number=" +
					this.value.clc_id_number,
				showHeader: true,
				enableHighlights: true,
				// enableRowSelect: true,
				enableSaveFilter: true,
				columns: [],
				actions: [
					{
						title: this.$t("edit"),
						icon: "edit",
						type: "none",
						// component: "app-add-modal",
						component: "school-history-table-form",
						modalId: "school-history-table-form",
					},
					{
						title: this.$t("delete"),
						icon: "trash",
						type: "none",
						component: "app-confirmation-modal",
						modalId: "demo-delete",
					},
				],
				showFilter: true,
				showSearch: true,
				showCount: true,
				showClearFilter: true,
				paginationType: "pagination",
				responsive: true,
				rowLimit: 3,
				showAction: true,
				orderBy: "desc",
				actionType: "default",
			},
		};
	},
	methods: {},
};
